import { combineReducers } from "redux";
import { permissionReducer } from "./permissionReducer";
import { toastReducer } from "./toastReducer";
import { userReducer } from "./userReducer";
import { quickImportReducer } from "./quickImportReducer";
import { mappingReducer } from "./mappingReducer";
import { nofiticationReducer } from "./notificationReducer";
import { dataSourceReducer } from "./datasourceReducer";
import { entityReducer } from "./entityReducer";
import { configReducer } from "./configReducer";
import { processQueueReducer } from "./processQueueReducer";
import { dataPipelineReducer } from "./datapipeline";
import { workspaceReducer } from "./workspaceReducer";
import { computeClusterReducer } from "./clusterReducer";
import { popupReducer } from "./popupReducer";
import { sideNavbarReducer } from "./sideNavbarReducer";
import { helpReducer } from "./helpReducer";
import { casesReducer } from "./casesReducer";

const rootReducer = combineReducers({
  user: userReducer,
  toast: toastReducer,
  permissions: permissionReducer,
  runningProcesses: quickImportReducer,
  showMapping: mappingReducer,
  notifications: nofiticationReducer,
  dataSourceData: dataSourceReducer,
  entititData: entityReducer,
  config: configReducer,
  processQueue: processQueueReducer,
  dataPipeline: dataPipelineReducer,
  workspace: workspaceReducer,
  clusterList: computeClusterReducer,
  openAppDrawer: popupReducer,
  sideNavbar: sideNavbarReducer,
  helpPanel: helpReducer,
  casesSelection: casesReducer,
});

export default rootReducer;
